/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AdjustTracker model module.
 * @module model/AdjustTracker
 * @version 1.0.0
 */
class AdjustTracker {
    /**
     * Constructs a new <code>AdjustTracker</code>.
     * @alias module:model/AdjustTracker
     */
    constructor() { 
        
        AdjustTracker.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AdjustTracker</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AdjustTracker} obj Optional instance to populate.
     * @return {module:model/AdjustTracker} The populated <code>AdjustTracker</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AdjustTracker();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('first_tracker')) {
                obj['first_tracker'] = ApiClient.convertToType(data['first_tracker'], 'String');
            }
            if (data.hasOwnProperty('first_tracker_name')) {
                obj['first_tracker_name'] = ApiClient.convertToType(data['first_tracker_name'], 'String');
            }
            if (data.hasOwnProperty('tracker')) {
                obj['tracker'] = ApiClient.convertToType(data['tracker'], 'String');
            }
            if (data.hasOwnProperty('tracker_name')) {
                obj['tracker_name'] = ApiClient.convertToType(data['tracker_name'], 'String');
            }
            if (data.hasOwnProperty('request_id')) {
                obj['request_id'] = ApiClient.convertToType(data['request_id'], 'String');
            }
            if (data.hasOwnProperty('remote_ip')) {
                obj['remote_ip'] = ApiClient.convertToType(data['remote_ip'], 'String');
            }
            if (data.hasOwnProperty('user_agent')) {
                obj['user_agent'] = ApiClient.convertToType(data['user_agent'], 'String');
            }
            if (data.hasOwnProperty('adid')) {
                obj['adid'] = ApiClient.convertToType(data['adid'], 'String');
            }
            if (data.hasOwnProperty('raw_params')) {
                obj['raw_params'] = ApiClient.convertToType(data['raw_params'], Object);
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AdjustTracker</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AdjustTracker</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['first_tracker'] && !(typeof data['first_tracker'] === 'string' || data['first_tracker'] instanceof String)) {
            throw new Error("Expected the field `first_tracker` to be a primitive type in the JSON string but got " + data['first_tracker']);
        }
        // ensure the json data is a string
        if (data['first_tracker_name'] && !(typeof data['first_tracker_name'] === 'string' || data['first_tracker_name'] instanceof String)) {
            throw new Error("Expected the field `first_tracker_name` to be a primitive type in the JSON string but got " + data['first_tracker_name']);
        }
        // ensure the json data is a string
        if (data['tracker'] && !(typeof data['tracker'] === 'string' || data['tracker'] instanceof String)) {
            throw new Error("Expected the field `tracker` to be a primitive type in the JSON string but got " + data['tracker']);
        }
        // ensure the json data is a string
        if (data['tracker_name'] && !(typeof data['tracker_name'] === 'string' || data['tracker_name'] instanceof String)) {
            throw new Error("Expected the field `tracker_name` to be a primitive type in the JSON string but got " + data['tracker_name']);
        }
        // ensure the json data is a string
        if (data['request_id'] && !(typeof data['request_id'] === 'string' || data['request_id'] instanceof String)) {
            throw new Error("Expected the field `request_id` to be a primitive type in the JSON string but got " + data['request_id']);
        }
        // ensure the json data is a string
        if (data['remote_ip'] && !(typeof data['remote_ip'] === 'string' || data['remote_ip'] instanceof String)) {
            throw new Error("Expected the field `remote_ip` to be a primitive type in the JSON string but got " + data['remote_ip']);
        }
        // ensure the json data is a string
        if (data['user_agent'] && !(typeof data['user_agent'] === 'string' || data['user_agent'] instanceof String)) {
            throw new Error("Expected the field `user_agent` to be a primitive type in the JSON string but got " + data['user_agent']);
        }
        // ensure the json data is a string
        if (data['adid'] && !(typeof data['adid'] === 'string' || data['adid'] instanceof String)) {
            throw new Error("Expected the field `adid` to be a primitive type in the JSON string but got " + data['adid']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
AdjustTracker.prototype['id'] = undefined;

/**
 * @member {Number} user_id
 */
AdjustTracker.prototype['user_id'] = undefined;

/**
 * @member {String} first_tracker
 */
AdjustTracker.prototype['first_tracker'] = undefined;

/**
 * @member {String} first_tracker_name
 */
AdjustTracker.prototype['first_tracker_name'] = undefined;

/**
 * @member {String} tracker
 */
AdjustTracker.prototype['tracker'] = undefined;

/**
 * @member {String} tracker_name
 */
AdjustTracker.prototype['tracker_name'] = undefined;

/**
 * @member {String} request_id
 */
AdjustTracker.prototype['request_id'] = undefined;

/**
 * @member {String} remote_ip
 */
AdjustTracker.prototype['remote_ip'] = undefined;

/**
 * @member {String} user_agent
 */
AdjustTracker.prototype['user_agent'] = undefined;

/**
 * @member {String} adid
 */
AdjustTracker.prototype['adid'] = undefined;

/**
 * 受信時の生パラメータ（JSON）
 * @member {Object} raw_params
 */
AdjustTracker.prototype['raw_params'] = undefined;

/**
 * @member {Date} created_at
 */
AdjustTracker.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AdjustTracker.prototype['updated_at'] = undefined;






export default AdjustTracker;

